import { usePlanosContext } from '@/pages/Planos'
import { PlanoFixo } from '@/service/api'
import { useMemo } from 'react'
import { useSearchParams } from 'react-router-dom'

export default function usePlanoByParam() {
    const { planos = [], PlanoDiferenciado } = usePlanosContext()
    const [params] = useSearchParams()
    const paramsId = String(params.get('p'))

    const plano = useMemo(() => {
        // if params is an UUIDv4
        if (
            new RegExp(
                '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$',
            ).test(paramsId)
        ) {
            return planos.find(it => it.legacyMyId === paramsId)
        }

        const [limite, periodicidade] = paramsId.split('-')

        if (limite == '0') {
            if (!PlanoDiferenciado) return undefined
            return {
                limiteFuncionarios: 0,
                periodicity: PlanoDiferenciado.periodicidade,
                price: PlanoDiferenciado.valorCentavos,
            } as PlanoFixo
        }
        return planos.find(
            it =>
                it.limiteFuncionarios == Number(limite) &&
                it.periodicity === periodicidade,
        )
    }, [planos.length, paramsId, !!PlanoDiferenciado])

    return plano
}
